import { Flex, Typography, Input } from "antd";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { DocstoreSections } from "../../../../../../model";
import { DocstoreUploadForm, FieldConfig } from "../../model/types";

interface IModalInput {
  fieldConfig: FieldConfig;
  selectedSection: (typeof DocstoreSections)[keyof typeof DocstoreSections];
  control: Control<DocstoreUploadForm>;
}

const getInputWidth = (fieldName: string) => {
  if (fieldName === "documentNumber") {
    return "30%";
  }

  if (fieldName === "documentCode") {
    return "50%";
  }

  if (fieldName === "pages") {
    return "20%";
  }

  return "100%";
};

export function ModalInput({
  fieldConfig,
  selectedSection,
  control,
}: IModalInput) {
  return (
    <Flex vertical gap="4px">
      <Typography.Text>
        {fieldConfig.title}
        &nbsp;
        {selectedSection !== DocstoreSections.PERMITS &&
          selectedSection !== DocstoreSections.EXECUTIVE_SCHEME &&
          fieldConfig.name === "description" &&
          "(необязательно)"}
      </Typography.Text>
      <FormItem<DocstoreUploadForm>
        name={fieldConfig.name as keyof DocstoreUploadForm}
        control={control}
        style={{ marginBottom: 0 }}
      >
        <Input
          required={fieldConfig.required}
          style={{
            width: getInputWidth(fieldConfig.name),
          }}
        />
      </FormItem>
    </Flex>
  );
}
